<template lang="pug">
v-card.elevation-ws(style="border:1px solid rgb(245,141,55);")
	v-toolbar.sticky.pr-0(color="rgb(253,225,191)" flat dense)
		h2.pt-2
			v-icon.mr-3 coronavirus
			| {{$t('corona.info.title', {destination: destination.name})}}
	v-spacer
	v-card-text
		p
			i18n(path="corona.info.intro")
				template(#destination) {{destination.name}}
				template(#url v-if="destination.corona.url")
					a(:href="destination.corona.url" target="_blank") {{$t('corona.info.area.website')}}
				template(#url v-else) {{$t('corona.info.area.website')}}
		h3.mt-0.subtitle-1.font-weight-bold {{$t('corona.info.list.title', {destination: destination.name})}}
		ul
			li(v-for="(measure,index) in measures" :key="measure" v-if="index < 5 || showMore") {{measure}}
		.text-center(v-if="destination.corona.measures.length>5 && showMore === false")
			v-btn.mt-4(color="rgb(245,141,55)" outlined @click="showMore = true") {{$t('corona.info.more.info')}}
		p.mt-6(v-if="showMore || destination.corona.measures.length <= 5")
			small {{$t('corona.info.disclaimer')}}
</template>
<script>
export default {
	name: 'CoronaInfo',
	props: {
		destination: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			showMore: false
		};
	},
	computed: {
		measures() {
			return this.destination.corona.measures.map(measure => {
				if (measure.substr(0, 5) === 'item.') {
					return this.$t(`corona.info.list.${measure}`);
				}
				return measure;
			});
		}
	}
};
</script>
